var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import { default as AntProgress } from 'antd/lib/progress';

var Progress = function (_super) {
  __extends(Progress, _super);

  function Progress() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Progress.prototype.render = function () {
    var _a = this.props,
        percent = _a.percent,
        status = _a.status,
        showInfo = _a.showInfo;
    var progressProps = {
      percent: parseFloat(Math.min(percent, 100).toString()),
      status: status,
      showInfo: showInfo,
      format: function format() {
        return percent + '%';
      }
    };
    return React.createElement(AntProgress, __assign({}, progressProps));
  };

  return Progress;
}(PureComponent);

export { Progress };